import {
  useGetUnreadCountApiV1NotificationsUnreadCountGet,
  useListNotificationsApiV1NotificationsGet,
  useMarkAllReadApiV1NotificationsReadAllPost,
} from "../../../../vl-api/vlComponents";
import { useCallback, useEffect } from "react";
import { UserNotification } from "../../../../vl-api/vlSchemas";
import { useNavigate } from "react-router-dom";

export const useUserNotifications = (datasetId: string) => {
  const notificationsQuery = useListNotificationsApiV1NotificationsGet({
    queryParams: { dataset_id: datasetId },
  });
  const unreadCountQuery = useGetUnreadCountApiV1NotificationsUnreadCountGet({
    queryParams: { dataset_id: datasetId },
  });
  const navigate = useNavigate();
  const refetchData = useCallback(() => {
    notificationsQuery.refetch();
    unreadCountQuery.refetch();
  }, [notificationsQuery, unreadCountQuery]);
  const markAllReadMutation = useMarkAllReadApiV1NotificationsReadAllPost({
    onSuccess: () => {
      refetchData();
    },
  });
  const handleNotificationClick = (notification: UserNotification) => {
    navigate(
      `/dataset/${datasetId}/views?name=${notification.metadata!.view_name}`,
    );
  };
  useEffect(() => {
    const eventSource = new EventSource(
      `/api/v1/notifications/stream?dataset_id=${datasetId}`,
    );
    eventSource.addEventListener("notification", () => {
      refetchData();
    });
    eventSource.addEventListener("ping", () => {});
    return () => {
      if (eventSource.readyState === eventSource.OPEN) {
        eventSource.close();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    isLoading: notificationsQuery.isLoading,
    notifications: notificationsQuery.data?.notifications ?? [],
    unreadCount: unreadCountQuery?.data?.count ?? 0,
    markAllRead: () => markAllReadMutation.mutate({}),
    handleNotificationClick,
  };
};
